import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlaystationvitaComponent } from './simple-icons-playstationvita.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlaystationvitaComponent ],
    exports:      [ SimpleIconsPlaystationvitaComponent ],
    bootstrap:    []
})
export class SimpleIconsPlaystationvitaModule {}
